import React from 'react';
import _ from 'lodash';
import config from 'config';

const icon = 'https://res.cloudinary.com/dljcvcx8l/image/upload/v1530572269/logo150x150_sgb249.png';

const trybePubKey = config.stripePubKey;


//This version isn't used, but auto-opens Stripe Checkout for user
//When from mobile, instead of being redirected to a full page Checkout experience,
//User sees a small modal in page which is suboptimal
class UserUpdateCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConf: false,
      cardSubmitted: false,
      uid: this.getURLVal('uid'),
      email: this.getURLVal('email')
    };
  }

  componentDidMount(){
    this.loadStripe(this.configureStripe);
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.updateCardStatus !== this.props.updateCardStatus){
      this.setState({ showConf: true });
    }
  }

  configureStripe = async () => {
    this.stripehandler = await window.StripeCheckout.configure({
      key: trybePubKey,
      image: icon,
      locale: 'auto',
      zipCode: true,
      token: (stripeData) => {
        this.setState({ cardSubmitted: true });

        const { uid } = this.state;
        const { paymentActions } = this.props.actions;

        if(!stripeData || !uid){
          alert('Something went wrong, please refresh the page and try again.');
        }

        paymentActions.initUpdateCard(uid, stripeData);
        paymentActions.listenUpdateCardResponse(uid);
      }
    });

    return this.stripehandler;
  }

  loadStripe = async (configureStripe) => {
    if(!window.StripeCheckout) {
      const script = document.createElement('script');
      script.onload = async () => {
        await configureStripe();
      };
      script.src = 'https://checkout.stripe.com/checkout.js';
      document.head.appendChild(script);
    } else {
      await configureStripe();
    }
  }

  openStripe(e) {
    this.stripehandler.open({
      name: 'Trybe',
      image: icon,
      panelLabel: 'Update Card',
      email: this.state.email || null,
    });
  }

  getURLVal(key){
    let result = null;
    const query = window.location.search.substring(1);
    const strings = query.split('&');
    _.each(strings, (string) => {
      const pair = string.split('=');
      let currKey = pair[0];
      if(currKey == key){
        let currVal = pair[1];
        currVal = currVal.replace('+',' ');
        result = currVal;
      }
    });

    return result;
  }

  renderConfirmation(){
    const showConf = this.state.showConf ? true : false;
    if(!showConf) return null;

    const { updateCardStatus } = this.props;
    if(updateCardStatus === 'success'){
      return (
        <div className='full-scene flex-column'>
          <img
            src={require('../../images/confirmationCheckmark.png')}
            className='confirmation-checkmark-lrg'
          />
          <div className='status-text'>
            Payment Method Successfully Updated
          </div>
        </div>
      )
    } else if(updateCardStatus === 'err'){
      return (
        <div className='full-scene flex-column'>
          <img
            src={require('../../images/error.png')}
            className='error-icon'
          />
          <div className='status-text'>
            Sorry something went wrong, please email support@trybe.do for assistance.
          </div>
        </div>
      )
    }
  }

  renderLoading = () => {
    return (
      <div className='full-scene flex-column'>
        <div className='app-start-loader'>
        </div>
      </div>
    )
  }

  renderCTA = () => {
    return (
      <div className='full-scene flex-column'>
        <text className='cta-text'>
          Update card details for
        </text>
        <text className='cta-text bold-text'>
          {this.state.email}
        </text>
        <button
          className='custom-button'
          onClick={ (e) => this.openStripe.bind(this, e)() }>
          Update Credit Card
        </button>
        <div className='secure-row-container'>
          <img
            src={require('../../images/lock.png')}
            className='lock-icon'
          />
          <text className='security-text'>
            Secure SSL Encryption
          </text>
        </div>
      </div>
    )
  }

  render() {
    let toRender;
    const { cardSubmitted, showConf } = this.state;

    if(!cardSubmitted && !showConf){
      toRender = this.renderCTA()
    } else if(cardSubmitted && !showConf){
      toRender = this.renderLoading()
    } else if(showConf){
      toRender = this.renderConfirmation()
    }

    return (
      <div className='update-card-container flex-column'>
        { toRender }
      </div>
    );
  }
}

module.exports = UserUpdateCard;


// WEBPACK FOOTER //
// ./src/components/payments/UserUpdateCard.js